import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { Observable } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../../services/media-query.service';

@Component({
  selector: 'td-wb-mobile-toolbar',
  templateUrl: 'mobile-toolbar.component.html',
  styleUrls: ['mobile-toolbar.component.scss'],
  imports: [
    AsyncPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileToolbarComponent {

  @HostBinding('class.td-wb-mobile-toolbar') toolbarClass: boolean = true;

  breakpointChanges$: Observable<BreakpointState>;

  constructor(private mediaQueryService: MediaQueryService) {
    this.breakpointChanges$ = this.mediaQueryService.observe(Breakpoint.SM, Breakpoint.MD);
  }
}
